import {fabric} from 'fabric'

export function measurement(canvas) {
    let selectedShape;
    let pointer;
    //let startX, startY, origX, origY;
    let  line, arrow, arrow2;
    let linex,liney,arrowx,arrowy,arrow2x,arrow2y;

    let stroke = 'black';
    let fill = 'transparent';
    canvas.on('mouse:down', function(option) {

       // if(option.target != null) {
         //   return;
       // } else {
        if((option.target == null) || (option.target.type === 'image') ){
            pointer = canvas.getPointer(option.e);
            let arrowLinePoints = [pointer.x, pointer.y, pointer.x, pointer.y];

            // startX = pointer.x;
            // startY = pointer.y;

            line = new fabric.Line(arrowLinePoints, {
                fill: fill,
                stroke: stroke,
                strokeWidth: 1.5,
                centeredRotation: false,
                hasBorders: false,
                hasControls:false
            });

            // reference points for arrowhead
            // origX = line.x2;
            // origY = line.y2;

            let dx = line.x2 - line.x1,
                dy = line.y2 - line.y1;

            /* calculate angle of arrow */
            let angle = Math.atan2(dy, dx);
            angle *= 180 / Math.PI;
            angle += 90;
            angle += 180;

            arrow = new fabric.Path('M 0 0 L 12 0',{
                angle: angle,
                fill: 'black',
                top: line.y2,
                left: line.x2,
                width: 7,
                height: 7,
                originX: 'center',
                originY: 'center',
                stroke: stroke
            });

            let angle2 = Math.atan2(dy, dx);
            angle2 *= 180 / Math.PI;
            angle2 += 90;

            arrow2 = new fabric.Path('M 0 0 L 12 0', {
                angle: angle2,
                fill: 'black',
                top: line.y2,
                left: line.x2,
                width: 7,
                height: 7,
                originX: 'center',
                originY: 'center',
                stroke: stroke
            });
            canvas.add(line);
            canvas.add(arrow);
            canvas.add(arrow2);
            canvas.renderAll();

            canvas.on("mouse:move", function(option) {
                pointer = canvas.getPointer(option.e);

                line.set({
                    x2: pointer.x,
                    y2: pointer.y,
                });

                let dx = line.x2 - line.x1,
                    dy = line.y2 - line.y1;

                let angle = Math.atan2(dy, dx);
                angle *= 180 / Math.PI;
                angle += 90;
                angle += 180;

                let angle2 = Math.atan2(dy, dx);
                angle2 *= 180 / Math.PI;
                angle2 += 90;

                arrow2.set({top: line.y2, left: line.x2, angle: angle2,
                    width: 7, height: 7});
                arrow.set({angle:angle});
                linex= line.left;
                liney= line.top;
                arrowx = arrow.left;
                arrowy = arrow.top;
                arrow2x = arrow2.left;
                arrow2y = arrow2.top; 
                canvas.renderAll();

            });

        }
    });

    canvas.on('mouse:up', function(option) {
         canvas.off('mouse:move');
        canvas.off('mouse:down');
        canvas.off('mouse:up');
        //canvas.deactivateAll();
        canvas.remove(line);
        canvas.remove(arrow);
        canvas.remove(arrow2);
        arrow.set({left:arrowx,top:arrowy});
        arrow2.set({left:arrow2x,top:arrow2y});
        line.set({left:linex,top:liney});
        let text;
        if(line && arrow && arrow2){
            selectedShape = new fabric.Group([line, arrow,arrow2], {
                hasBorders: true,
                hasControls: true,
            });
            selectedShape['groupType'] = "autoCreated";
            const centrePos =selectedShape.getCenterPoint()
             text = new fabric.Textbox('  ',{
                left: centrePos.x-10,
                top: centrePos.y-8,
                fontSize: 12,
                lineHeight: 0.01,
                opacity:1,
                fontFamily: 'Verdana',
                backgroundColor:'aliceblue'
            });
            canvas.add(selectedShape);
            selectedShape.addWithUpdate(text);

            text.enterEditing();
            if(line){
                let dx = line.x2 - line.x1,
                    dy = line.y2 - line.y1;
                let angle = Math.atan2(dy, dx);
                angle *= 180 / Math.PI;
                angle += 180;
                angle =parseInt(angle.toString().split('.')[0])
                angle =angle%180


                /*to adjust text alignment  with increasing number of text wip*/
                const lineLength = Math.sqrt(Math.pow(line.x2*1-line.x1*1, 2)+Math.pow(line.y2*1-line.y1*1, 2))

                text.set({
                    fixedWidth: lineLength/4
                })
                
                /* To change textbox alignment for vertical lines*/
                if(text && (angle>10 && angle<=170) && lineLength > 60){
                    text.set({angle:angle,left: 9})
                }
                
                text.on('changed', function(opt) {
                    const t1 = text;
                    if (t1.width > t1.fixedWidth) {
                        if(text && (angle>10 && angle<=170) && lineLength > 60) {
                            text.set({
                                top: text.top - 8,
                                fixedWidth: text.width + 10
                            })
                        }
                        else{
                            text.set({
                                left: text.left - 8,
                                fixedWidth: text.width + 10
                            })
                        }
                    }
                });
            }

        }


    });



}